import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { apiService } from "../../services/apiService";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import Pagination from "../../components/Pagination";

const TransactionManagement = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage] = useState(10);
  const [showCreateSubscriptionModal, setShowCreateSubscriptionModal] = useState(false);
  const [selectedTransactionForSubscription, setSelectedTransactionForSubscription] = useState(null);
  const [creatingSubscription, setCreatingSubscription] = useState(false);

  const fetchTransactions = async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        page_size: itemsPerPage.toString(),
      });

      const response = await apiService.get(
        `${API_ENDPOINTS.SUBSCRIPTIONS.TRANSACTION_FAILED_LIST}?${params.toString()}`
      );
      console.log(response);

      if (response) {
        setTransactions(response.results || response.data || response);
        setTotalPages(response.total_pages || Math.ceil((response.count || 0) / itemsPerPage));
        setTotalCount(response.count || response.total || 0);
        setCurrentPage(page);
      } else {
        toast.error(response.message || "Failed to fetch transactions");
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      toast.error("Failed to fetch transactions");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    fetchTransactions(page);
  };

  const openCreateSubscriptionModal = (transaction) => {
    setSelectedTransactionForSubscription(transaction);
    setShowCreateSubscriptionModal(true);
  };

  const closeCreateSubscriptionModal = () => {
    setShowCreateSubscriptionModal(false);
    setSelectedTransactionForSubscription(null);
  };

  const createSubscription = async () => {
    if (!selectedTransactionForSubscription) return;
    
    setCreatingSubscription(true);
    try {
      const transactionId = selectedTransactionForSubscription.transaction_id || selectedTransactionForSubscription.id;
      const apiEndpoint = `subscriptions/transaction/failed/${transactionId}/create-subscription/`;
      
      console.log('Creating subscription for transaction:', transactionId);
      console.log('API endpoint:', apiEndpoint);
      
      const response = await apiService.post(apiEndpoint);
      
      if (response) {
        toast.success("Subscription created successfully!");
        closeCreateSubscriptionModal();
        fetchTransactions(currentPage);
      } else {
        toast.error(response.message || "Failed to create subscription");
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
      toast.error("Failed to create subscription");
    } finally {
      setCreatingSubscription(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };


  useEffect(() => {
    fetchTransactions();
  }, []);

  return (
    <>
      <div className="page-header mb-3">
        <div className="row align-items-center">
          <div className="col">
            <h3 className="page-title">Transaction Management</h3>
          </div>
          <div className="col-auto text-end float-end ms-auto">
            <button 
              className="btn btn-outline-primary me-2" 
              onClick={() => fetchTransactions(currentPage)}
              disabled={loading}
            >
              <i className="fe fe-refresh-cw"></i> Refresh
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Transactions List</h5>
              <p className="text-muted mb-0">
                <span className="badge bg-primary ms-2">Total: {totalCount}</span>
              </p>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                      <th>Sr.No</th>
                        <th>Transaction ID</th>
                        <th>Razorpay Order Id</th>
                        <th>Razorpay Payment Id</th>
                        <th>User</th>
                        <th>Payment Status</th>
                        <th>Subscription Status</th>
                        <th>Is Resolved</th>
                        <th>Created Date</th>
                        {transactions.some(transaction => !transaction.is_resolved) && <th>Actions</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.length === 0 ? (
                        
                        <tr>
                          <td colSpan={transactions.some(transaction => !transaction.is_resolved) ? "7" : "9"} className="text-center py-4">
                            <div className="text-muted">
                              <i className="fe fe-inbox fs-1 d-block mb-2"></i>
                              No transactions found
                            </div>
                          </td>
                        </tr>
                      ) : (
                        transactions.map((transaction, index) => (

                          <tr key={index}>
                             <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                            <td>
                              <code className="text-primary">{transaction.transaction_id}</code>
                            </td>
                            <td>
                              <code className="text-primary">{transaction.razorpay_order_id}</code>
                            </td>
                              <td>
                              <code className="text-primary">{transaction.razorpay_payment_id}</code>
                            </td>
                            
                            <td>
                              <div>
                                <div className="fw-bold">{transaction.user}</div>
                              </div>
                            </td>
                            <td>
                              <span className={`badge ${transaction.payment_received ? 'bg-success' : 'bg-danger'}`}>
                                {transaction.payment_received ? 'RECEIVED' : 'NOT RECEIVED'}
                              </span>
                            </td>
                            <td>
                              <span className={`badge ${transaction.subscription_status ? 'bg-success' : 'bg-warning'}`}>
                                {transaction.subscription_status ? 'ACTIVE' : 'INACTIVE'}
                              </span>
                            </td>
                            <td>
                              <span className={`badge ${transaction.is_resolved ? 'bg-success' : 'bg-warning'}`}>
                                {transaction.is_resolved ? 'RESOLVED' : 'PENDING'}
                              </span>
                            </td>
                            <td>{formatDate(transaction.created_at)}</td>
                            {transactions.some(t => !t.is_resolved) && (
                              <td>
                                <div className="actions">
                                  {!transaction.is_resolved && (
                                    <button
                                      className="btn btn-sm btn-outline-success"
                                      onClick={() => openCreateSubscriptionModal(transaction)}
                                      title="Create Subscription"
                                    >
                                      <i className="fe fe-edit"></i>
                                    </button>
                                  )}
                                </div>
                              </td>
                            )}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              loading={loading}
              showPageInfo={true}
            />
          </div>
        </div>
      </div>

      {showCreateSubscriptionModal && selectedTransactionForSubscription && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create Subscription</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeCreateSubscriptionModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info">
                  <i className="fe fe-info me-2"></i>
                  Are you sure you want to create a subscription for this failed transaction?
                </div>
                
                <div className="row">
                  <div className="col-12">
                    <h6>Transaction Details</h6>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td><strong>Transaction ID:</strong></td>
                          <td><code>{selectedTransactionForSubscription.transaction_id}</code></td>
                        </tr>
                        <tr>
                          <td><strong>User:</strong></td>
                          <td>{selectedTransactionForSubscription.user}</td>
                        </tr>
                        <tr>
                          <td><strong>Payment Received:</strong></td>
                          <td>
                            <span className={`badge ${selectedTransactionForSubscription.payment_received ? 'bg-success' : 'bg-danger'}`}>
                              {selectedTransactionForSubscription.payment_received ? 'RECEIVED' : 'NOT RECEIVED'}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Razorpay Order ID:</strong></td>
                          <td><code>{selectedTransactionForSubscription.razorpay_order_id}</code></td>
                        </tr>
                        <tr>
                          <td><strong>Razorpay Payment ID:</strong></td>
                          <td><code>{selectedTransactionForSubscription.razorpay_payment_id}</code></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={closeCreateSubscriptionModal}
                  disabled={creatingSubscription}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={createSubscription}
                  disabled={creatingSubscription}
                >
                  {creatingSubscription ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Creating...
                    </>
                  ) : (
                    <>
                      <i className="fe fe-check me-2"></i>
                      Create Subscription
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCreateSubscriptionModal && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};

export default TransactionManagement;
